import { render, staticRenderFns } from "./BbeeAccesosDirectosCT.vue?vue&type=template&id=f9cf5ba8"
import script from "./BbeeAccesosDirectosCT.vue?vue&type=script&lang=js"
export * from "./BbeeAccesosDirectosCT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports